/**
 * Tiny DOM helpers for writing/updating <head> meta + link tags. Extracted
 * out of SEOHead.jsx so that component stays a thin orchestrator instead of
 * a 60-line procedural blob (was CC 21 → now CC 4).
 */
const SITE_SUFFIX = "Circularity Global";

function setMeta(attr, key, value) {
  if (value === undefined || value === null) return;
  let m = document.querySelector(`meta[${attr}="${key}"]`);
  if (!m) {
    m = document.createElement("meta");
    m.setAttribute(attr, key);
    document.head.appendChild(m);
  }
  m.setAttribute("content", value);
}

function setLink(rel, href) {
  let l = document.querySelector(`link[rel="${rel}"]`);
  if (!l) {
    l = document.createElement("link");
    l.setAttribute("rel", rel);
    document.head.appendChild(l);
  }
  l.setAttribute("href", href);
}

export function applyTitle({ title, desc }) {
  if (title) {
    document.title = title.includes(SITE_SUFFIX) ? title : `${title} · ${SITE_SUFFIX}`;
  }
  if (desc) setMeta("name", "description", desc);
}

export function applyCanonical(canonical) {
  setLink("canonical", canonical);
}

export function applyOpenGraph({ copy, canonical, image, locale }) {
  setMeta("property", "og:site_name", SITE_SUFFIX);
  setMeta("property", "og:title",     copy.title || SITE_SUFFIX);
  setMeta("property", "og:description", copy.desc);
  setMeta("property", "og:type",      "website");
  setMeta("property", "og:url",       canonical);
  setMeta("property", "og:image",     image);
  setMeta("property", "og:image:type", "image/jpeg");
  setMeta("property", "og:image:width",  "1200");
  setMeta("property", "og:image:height", "630");
  setMeta("property", "og:locale",    locale);
}

export function applyTwitter({ copy, image }) {
  setMeta("name", "twitter:card",        "summary_large_image");
  setMeta("name", "twitter:title",       copy.title || SITE_SUFFIX);
  setMeta("name", "twitter:description", copy.desc);
  setMeta("name", "twitter:image",       image);
}
